export const ACTING_CONTEXT_CHANGED_EVENT = 'acting-context-changed';
